import { IStoreState } from '../types/StoreState';

export const selectExpandedCardId = (state: IStoreState) => state.ui.expandCardId;
export const selectShowRemovalConfirmation = (state: IStoreState) => state.ui.showRemovalConfirmation;
export const selectShowCardAddedMessage = (state: IStoreState) => state.ui.showCardAddedMessage;
